import React from 'react';
import { RobotOutlined, UserOutlined } from '@ant-design/icons';
import { resolveCapabilityModeIcon } from '../../capabilities/capabilityIcons.jsx';

const assistantDisplayName = (assistantName) => String(assistantName || '').trim() || '助手';
const assistantVisibleLabel = (assistantName, messageIdentityKey) => (
  messageIdentityKey === 'expert' ? '深度执行' : assistantDisplayName(assistantName)
);

const identityLabel = (role, messageIdentityKey, assistantName) => {
  if (role === 'user') return '用户';
  const displayName = assistantDisplayName(assistantName);
  if (messageIdentityKey === 'auto') return `${displayName}，自动`;
  if (messageIdentityKey === 'expert') return `${displayName}，深度执行`;
  return displayName;
};

const avatarPresentation = ({ assistantName, messageIdentityKey, role, themeTokens }) => (
  role === 'user'
    ? {
      className: 'is-user',
      color: themeTokens.bubbleUserBg,
      defaultAvatar: <UserOutlined />,
      identity: 'user',
      label: '',
    }
    : {
      className: 'is-assistant',
      color: themeTokens.textSecondary,
      defaultAvatar: ['auto', 'expert'].includes(messageIdentityKey)
        ? resolveCapabilityModeIcon(messageIdentityKey)
        : <RobotOutlined />,
      identity: ['auto', 'expert'].includes(messageIdentityKey)
        ? messageIdentityKey
        : 'neutral',
      label: assistantVisibleLabel(assistantName, messageIdentityKey),
    }
);

export default function MessageIdentityAvatar({
  assistantName,
  messageIdentityKey = '',
  renderMessageAvatar,
  role,
  themeTokens,
}) {
  const presentation = avatarPresentation({ assistantName, messageIdentityKey, role, themeTokens });
  const customAvatar = typeof renderMessageAvatar === 'function'
    ? renderMessageAvatar({ role, messageIdentityKey })
    : null;
  return (
    <span
      aria-label={identityLabel(role, messageIdentityKey, assistantName)}
      className={`flare-message-avatar ${presentation.className}`}
      data-message-identity={presentation.identity}
      role="img"
      style={{
        color: presentation.color,
      }}
    >
      {customAvatar ?? presentation.defaultAvatar}
      {presentation.label ? (
        <span className="flare-message-identity-label">{presentation.label}</span>
      ) : null}
    </span>
  );
}
